import React from 'react';
import ReactDOM from 'react-dom';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

// Reactotron
import './config/ReactotronConfig';

import { Provider } from 'react-redux';

import { IntlProvider } from 'react-intl-redux';

import { ConnectedRouter } from 'connected-react-router';

import { PersistGate } from 'redux-persist/integration/react';
import ServiceForm from 'containers/ServiceForm';
import store, { history, persistor } from './store';

import App from './App';
import Routes from './routes';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <IntlProvider>
        <ConnectedRouter history={history}>
          <App>
            <Routes />
            <ServiceForm />
          </App>
        </ConnectedRouter>
      </IntlProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);
